import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+200',
  label: 'Ejercicios graficados'
}, {
  value: '+500',
  label: 'Profes satisfechos'
}, {
  value: '+300',
  label: 'Páginas listas'
}, {
  value: '4.9/5',
  label: 'Lo recomiendan'
}];
export function StatBadges() {
  return <section className="bg-white border-y border-primary/10" data-id="element-167" data-mp="2z9qn794zfw4j">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 px-4 py-10 md:py-12" data-id="element-168" data-mp="3d1x796b9an99">
        {stats.map((stat, index) => <motion.div key={stat.label} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.08
      }} className={`text-center px-2 py-4 md:py-0 border-primary/10 ${index % 2 === 1 ? 'border-l' : ''} ${index > 0 ? 'md:border-l' : 'md:border-l-0'}`} data-id="element-169" data-mp="3833ujg3sn0a5" data-mpi={index}>
            <div className="font-display font-black text-primary text-3xl md:text-5xl leading-none mb-2 md:mb-3" data-id="element-170" data-mp="1b3zygpxnlfzr">
              {stat.value}
            </div>
            <div className="text-[0.65rem] md:text-xs font-semibold uppercase tracking-[0.12em] text-primary/60" data-id="element-171" data-mp="1g21cuxk4wr4w">
              {stat.label}
            </div>
          </motion.div>)}
      </div>
    </section>;
}